export default function FormGroup({ children }) {
  return <div style={{ display: 'grid' }}>{children}</div>;
}
